export enum AppointmentTypesEnum {
  AT_MY_LOCATION = 'At my location',
  AT_YOUR_LOCATION = 'At your location',
  ONLINE = 'Online',
}
